import http from 'core/services/http';
import Config from 'core/config';

class DashboardService {
  static getUserAssignments(id) {
    return http.get(`${Config.apiUrl}/personnel/${id}/assignments`);
  }

  static getUserTestCenters(id) {
    return http.get(`${Config.apiUrl}/personnel/${id}/testcenterdto`);
  }

  static getAvailableTerms(userId, status) {
    return http.get(`${Config.apiUrl}/personnel/${userId}/availableterms/${status}`);
  }

  static acceptTerms(userId, termId) {
    return http.post(`${Config.apiUrl}/personnel/${userId}/terms/${termId}/accept`);
  }
}

export default DashboardService;
